import Svg from 'components/atoms/structure/Svg';
import ModalCard from 'components/organisms/layout/modals/ModalCard';
import React from 'react';
import { getSystemImageUrl } from 'utils/assets';
import PropTypes from 'prop-types';

import { Container, ImageContainer } from './styles';
import useFeedback from 'hooks/useFeedback';
import { FeedbackType } from 'types/components/feedback';
import { useSelector } from 'react-redux';

const FinishedCourseModal = ({ feedback }) => {
    const hook = useFeedback();
    const { points } = feedback;

    const auth = useSelector((state) => state.auth);
    const isEnterprise = auth.user?.enterpriseId;

    return (
        <ModalCard open={true} title="Curso Concluído" handleClose={hook.closeFeedback}>
            <Container>
                <h3>Super!</h3>
                <p>Você conseguiu finalizar um curso e ganhou:</p>

                <ImageContainer>
                    <Svg url={getSystemImageUrl('icone curso finalizado.svg')} width="75" height="68" />
                </ImageContainer>
                {!isEnterprise && points && <h2>+{points} pontos</h2>}
                <p>
                    para cada competência relacionada. <br /> Continue assim: Sempre avançando!
                </p>
            </Container>
        </ModalCard>
    );
};

FinishedCourseModal.propTypes = {
    feedback: PropTypes.shape(FeedbackType).isRequired
};

export default FinishedCourseModal;
